import type { PermissionSelector } from "@/hooks/usePermission";

export const canViewServicePartners: PermissionSelector = (x) => x.servicePartners.canListPages;

export const canCreateNewServicePartner: PermissionSelector = (x) => {
  return x.servicePartners.canManagePages || x.servicePartners.canCreatePages;
};
